<template>
    <div class="w-full mt-4">
        <form v-if="form">
            <div class="border-t-2 border-blue-600">
                <div class="relative border py-3 px-2 sm:px-3 bg-tan-200 flex flex-wrap">

                    <div class="w-full -mt-6 md:-mt-8 mb-6">
                        <alert-box v-if="isJims && !isJim()">
                            <template #body>
                                This is a copy of Jim's Template. Modifications are not allowed. Please make a copy to customize.
                            </template>
                        </alert-box>
                    </div>

                    <div class="w-full md:w-4/5 lg:w-2/3">
                        <!-- Disable all form elements if this is Jim's template -->
                        <fieldset :disabled="isJims && !isJim()">
                            <div class="mb-2 md:flex">
                                <label for="template-name" class="w-full md:w-1/4 lg:w-1/5">Template Name:</label>
                                <div class="w-full md:w-3/5 lg:w-2/5">
                                    <input :class="{'is-invalid': errors.name}" class="form-input-inline-w-none form-input-sm-inline w-full" type="text" v-model="form.name" name="name" id="template-name">
                                    <div v-if="errors.name" class="error">
                                        {{ errors.name }}
                                    </div>
                                </div>
                            </div>

                            <div class="mb-3 md:flex justify">
                                <label for="template-name" class="w-full md:w-1/4 lg:w-1/5">Description:</label>
                                <input class="form-input-inline-w-none form-input-sm-inline w-full md:w-3/5 lg:w-3/4" type="text" v-model="form.description" name="description" id="template-description" maxlength="255">
                            </div>

                            <div class="mb-3" v-if="isAdmin">
                                <label for="public-checkbox">Make this template public:</label>
                                <input class="form-control" id="public-checkbox" type="checkbox" v-model="form.public" name="public">
                            </div>
                        </fieldset>
                        <!-- End disabling form elements -->
                    </div>

                    <div class="w-full md:w-full lg:w-1/3 print:hidden">
                        <div class="flex justify-center lg:justify-end ml-auto mb-4">
                            <div class="btn btn-sm btn-yellow-ghost  mx-1" @click="emit('cancel')">Cancel</div>
                            <div :class="{'btn-yellow-ghost block': !isJims}"  class="btn btn-sm btn-yellow mx-1 " @click="chartTmplFormModal = 'copy'"><i class="far fa-copy"></i> Copy Template</div>
                            <div v-if="!isJims" class="btn btn-sm btn-yellow  mx-1" @click="save">Save</div><br>
                        </div>
                    </div>

                    <!-- Disable all form elements if this is Jim's template -->
                    <fieldset :disabled="isJims && !isJim()" class="border">

                        <div class="w-full inline-block px-4 py-3 bg-white border-t">
                            <h4>Display</h4>
                            <div class="flex flex-wrap settings-wrapper">
                                <div class="sm:w-1/2 lg:w-1/3 w-full sm:pr-2 pr-0">
                                    <display-settings v-model="form" :form="form"></display-settings>
                                </div>
                                <div class="sm:w-1/2 w-full lg:pl-8 sm:pl-4 pl-0">
                                    <scale-settings v-model="form" :form="form"></scale-settings>
                                </div>
                            </div>
                        </div>

                        <div class="w-full inline-block px-4 py-3 bg-white border-t">
                            <h4>Indicators</h4>
                            <div class="flex flex-row sm:w-1/2 lg:w-1/3 my-2 sm:pr-2 pr-0">
                                <select class="form-control form-control-sm" @change="selectIndicator(newIndicator)" v-model="newIndicator" name="indicator">
                                    <option :value="null">Add an Indicator...</option>
                                    <option :value="indicator" v-for="indicator in allIndicators">{{ indicator.meta.title }}</option>
                                </select>
                            </div>
                            <div class="flex flex-wrap -mx-1">
                                <div @click="showExistingIndicator(indicator)" v-for="indicator in templateIndicators" class="inline-block btn btn-xs btn-white btn-shadow-none btn-radius-none m-1 cursor-pointer leading-loose">
                                    <span class="text-blue-500 text-sm">{{ indicator.title }}</span>
                                    <i @click.stop="deleteTemplateIndicator(indicator)" class="fa fa-times text-red-500 cursor-pointer text-right ml-2"></i>
                                </div>
                            </div>
                        </div>
                    </fieldset>
                    <!-- End disabling form elements -->

                    <div class="w-full">
                        <div class="flex justify-center ml-auto mt-3 print:hidden">
                            <div class="btn btn-sm btn-yellow-ghost inline-flex mx-1" @click="emit('cancel')">Cancel</div>
                            <div v-if="!isJims || isJim()" class="btn btn-sm btn-yellow inline-flex mx-1" @click="save">Save Template</div>
                            <div v-if="isJims && !isJim()" class="btn btn-sm btn-yellow inline-flex mx-1" @click="chartTmplFormModal = 'copy'"><i class="far fa-copy mr-1"></i> Copy Template</div>
                        </div>
                    </div>

                </div>
            </div>

            <!-- Copy Template Modal -->
            <modal @close="chartTmplFormModal = null" v-if="chartTmplFormModal === 'copy'" className="max-w-sm w-full">
                <template #header>
                    <i class="far fa-copy mr-1"></i>
                    Copy Template
                </template>
                <template #body>
                    <div class="mb-3">
                        <div class="form-group">
                            <label for="template-name" class="w-full sm:w-auto">New Template Name:</label>
                            <input v-focus :class="{'is-invalid': errors.copyName}" class="form-input-inline-w-none form-input-sm-inline w-full" id="template-name" type="text" name="name" v-model="copyName">
                            <div v-if="errors.copyName" class="error">{{ errors.copyName }}</div>
                        </div>
                    </div>
                </template>
                <template #footer>
                    <div class="flex justify-center">
                        <div class="btn btn-sm btn-yellow-ghost inline-flex mx-1" @click="chartTmplFormModal = null">Cancel</div>
                        <div class="btn btn-sm btn-yellow inline-flex mx-1" @click="copy">Save Template</div>
                    </div>
                </template>
            </modal>

            <!-- Indicator Modal -->
            <modal @close="closeIndicatorModal" v-if="chartTmplFormModal === 'indicator'" className="max-w-sm w-full">
                <template #header>
                    Customize {{ getIndicatorName() }}
                </template>
                <template #body>
                    <div class="m-0 mt-2 mb-2 p-0 text-sm">
                        <selected-indicator
                            :default-placement="mSelectedIndicator.placement"
                            :indicator="mSelectedIndicator"
                            v-model="indicator"
                        />
                    </div>
                </template>
                <template #footer>
                    <div class="flex justify-center">
                        <div class="btn btn-sm btn-yellow-ghost inline-flex mx-1" @click="closeIndicatorModal">Cancel</div>
                        <div class="btn btn-sm btn-yellow inline-flex mx-1" @click="applyIndicator">Apply</div>
                    </div>
                </template>
            </modal>
        </form>
    </div>
</template>

<script setup>
import { ref, onMounted, nextTick } from 'vue';
import { useIsJim } from '../../mixins/IsJim';
import { useChartDefaultValues } from '../Chart/mixins/ChartDefaultValues';
import { useSettingsFormatter } from '../Chart/mixins/SettingsFormatter';

// import ChartSettings from '../Chart/Settings';

import DisplaySettings from '../Chart/DisplaySettings';
import ScaleSettings from '../Chart/ScaleSettings';
import SelectedIndicator from '../Chart/SelectedIndicator';
import Aggregation from '../Chart/Aggregation';

const props = defineProps({
    template: {
        type: Object,
        required: true
    },
    isJims: Boolean,
    // A "headless" version of the charts to show the indicators for a template
    headlessChart: Object,
    isAdmin: Boolean,
});

const $clone = (obj) => JSON.parse(JSON.stringify(obj));
const { isJim } = useIsJim();
const chartDefaultValues = useChartDefaultValues();

const emit = defineEmits(['update', 'save', 'copy', 'cancel']);

const chartTmplFormModal = ref(null);

const form = ref(null);

const settingsFormatter = useSettingsFormatter(form);

const copyName = ref('');
const templateIndicators = ref([]);
const allIndicators = ref([]);
const indicatorDefaults = ref([]);
const mSelectedIndicator = ref(null);
const indicator = ref(null);
const newIndicator = ref(null);
const originalForm = ref(null);
const errors = ref({
    name: false,
    copyName: false
});

function normalizeSettings() {
    let settings = {
        name: props.template.name,
        description: props.template.description
    };

    const template = props.template.template;

    // From ChartDefaultValues mixin
    const chartSettings = chartDefaultValues.getInitialValues(template);
    settings = Object.assign(settings, chartSettings);
    // originalForm.value = $clone(settings);
    return settings;
}

const deleteTemplateIndicator = (templateIndicator) => {
    if (props.isJims) return;

    templateIndicators.value = templateIndicators.value.filter(indicator => indicator.index !== templateIndicator.index);

    props.headlessChart.change({
        id: 'Plot',
        context: {
            id: 'Delete',
            type: 'Study',
            index: templateIndicator.index
        }
    });
};

const selectIndicator = () => {
    mSelectedIndicator.value = $clone(newIndicator.value.defaults);
    mSelectedIndicator.value.id = newIndicator.value.id;
    mSelectedIndicator.value.placement = newIndicator.value.meta.overlay ? 'overlay' : 'standalone';
    mSelectedIndicator.value.meta = newIndicator.value.meta;
    mSelectedIndicator.value.new = true;

    const defaultsFromLocalStorage = window.localStorage.getItem(newIndicator.value.id);

    if (defaultsFromLocalStorage) {
        mSelectedIndicator.value = Object.assign(mSelectedIndicator.value, JSON.parse(defaultsFromLocalStorage));
    }

    chartTmplFormModal.value = 'indicator';
};

const getIndicator = (id) => {
    return allIndicators.value.find(i => i.id === id);
};

const showExistingIndicator = (indicator) => {
    const getIndicatorDefaults = getIndicator(indicator.studyId);

    mSelectedIndicator.value = indicator;
    mSelectedIndicator.value.new = false;
    mSelectedIndicator.value.id = indicator.id;
    mSelectedIndicator.value.meta = getIndicatorDefaults.meta;

    indicatorDefaults.value = allIndicators.value.find(i => i.id === indicator.studyId).defaults;

    chartTmplFormModal.value = 'indicator';
};

const validate = () => {
    let valid = true;

    if (!form.value.name || form.value.name.length === 0) {
        errors.value.name = 'Please enter a template name';
        valid = false;
    }

    return valid;
};

const save = () => {
    if (!validate()) return;

    if (form.value.density === 'custom') {
        form.value.density = form.value.customDensity;
    }

    // HACK for Vertical Line
    // TODO: Revisit this later
    if (form.value.vertical && form.value.crosshair === false) {
        form.value.crosshair = 'vertical';

        setTimeout(() => {
            form.value.crosshair = false;
        }, 25);
    }

    if (form.value.crosshair === true) {
        form.value.crosshair = 'both';

        setTimeout(() => {
            form.value.crosshair = true;
        }, 25);
    }

    const templateActions = Object.keys(form.value)
        .filter(key => {
            if (key === 'preventLabelOverlap') return true;
            return (originalForm.value[key] !== form.value[key] && form.value[key] !== undefined);
        })
        .map((key) => {
            // Located in SettingsFormatter.vue
            return settingsFormatter.format(key, form.value[key]);
        }).filter(value => value !== undefined);

    props.headlessChart.change(...templateActions);

    const templateData = props.headlessChart.asTemplate({ main: true, annotations: true });

    const templateRecord = {
        id: props.template.id,
        name: form.value.name,
        description: form.value.description,
        public: form.value.public,
        template: templateData,
    };

    if (props.template.id) {
        emit('update', templateRecord);
    } else {
        emit('save', templateRecord);
    }

};

// const applyAggregation = (aggregation) => {
//     form.value.aggregation = aggregation.context;
//     props.headlessChart.change(aggregation);
// };

const copy = () => {
    if (copyName.value.length === 0) {
        errors.value.copyName = 'Please enter a template name';
    } else {
        emit('copy', props.template, copyName.value);
        chartTmplFormModal.value = null;
    }
};

// const storeIndicatorDefaultsInLocalStorage = () => {
//     window.localStorage.setItem(actions.value.context.studyId, JSON.stringify({
//         curves: actions.value.context.curves,
//         inputs: actions.value.context.inputs,
//         placement: actions.value.context.placement
//     }));
// };

const applyIndicator = () => {
    if (mSelectedIndicator.value.new) {
        return addIndicator();
    } else {
        return updateIndicator();
    }
};

const addIndicator = () => {
    const action = {
        id: 'Plot',
        context: {
            curves: indicator.value.curves,
            inputs: indicator.value.inputs,
            placement: indicator.value.placement,
            studyId: indicator.value.id,
            type: 'Study',
            id: 'Add'
        }
    };

    props.headlessChart.change(action);

    closeIndicatorModal();
    setTemplateIndicators();
};

const setTemplateIndicators = () => {
    const newTemplateIndicators = props.headlessChart.change({
        id: 'Plot',
        context: {
            id: 'Get',
            type: 'Study'
        }
    });``

    templateIndicators.value = newTemplateIndicators;
};

const updateIndicator = () => {
    const action = {
        id: 'Plot',
        context: {
            curves: indicator.value.curves,
            inputs: indicator.value.inputs,
            placement: indicator.value.placement,
            studyId: indicator.value.id,
            type: 'Study',
            id: 'Update',
            index: indicator.value.index
        }
    };

    props.headlessChart.change(action);

    closeIndicatorModal();
    setTemplateIndicators();
};

const closeIndicatorModal = () => {
    chartTmplFormModal.value = null;
    newIndicator.value = null;
};

const getIndicatorName = () => {
    const indicator = allIndicators.value.find(i => i.id === (mSelectedIndicator.value.studyId || mSelectedIndicator.value.id));

    if (!indicator) {
        return mSelectedIndicator.value.title;
    } else {
        return indicator.meta.title;
    }
};

onMounted(() => {
    nextTick(() => {
        const initialSettings = normalizeSettings();
        form.value = initialSettings;
        originalForm.value = $clone(initialSettings);

        if (Object.keys(props.template).length > 0) {
            // console.log('Init', props.template.template);
            props.headlessChart.load(JSON.stringify(props.template.template));
        }

        setTemplateIndicators();

        const indicators = window.Barchart.RealtimeWidgets.Charts.getTaxonomies().studies;

        indicators.map((indicator) => {
            if (indicator.meta.title === 'TrendSpotter') {
                indicator.meta.title = 'Trend Seeker';
                indicator.meta.caption = 'Trend Seeker';
            }

            return indicator;
        });

        allIndicators.value = indicators;
    });
});
</script>

<style lang="scss">
.settings-wrapper {
    @apply m-0 p-0 pb-2 text-sm;
    .column-title {
        @apply font-bold mt-2 mb-1;
    }

    ul {
        label {
            @apply text-sm font-normal;
        }
    }

    .visual-controls {
        li {
            @apply inline-flex self-center mr-2;

            label {
                @apply ml-1;
            }
        }
    }
}
</style>
